var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1172,
    height: 1279,
    viewBox: "0 0 1172 1279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M667.443 366.127C653.066 360.154 642.748 360.032 636.489 365.639C630.062 371.247 627.017 380.754 627.017 394.041V465.959C627.017 479.611 625.326 490.948 621.774 499.968C618.222 509.354 612.302 515.936 604.183 519.837C596.233 523.859 585.408 524.834 571.707 523.006C558.345 521.299 541.6 516.18 521.641 507.891L512.168 503.869V447.187L524.178 452.185C538.555 458.158 548.027 458.889 552.763 454.623C557.837 450.357 560.375 441.58 560.375 428.293V364.908C560.375 348.33 562.573 335.287 567.14 325.78C571.538 316.15 580.503 310.055 593.865 307.373C580.503 293.599 571.538 279.947 567.14 266.66C562.743 253.374 560.544 238.503 560.544 221.925V158.539C560.544 145.253 558.007 134.282 552.932 125.872C548.196 117.583 538.555 110.391 524.347 104.418L512.338 99.4203V42.739L521.81 46.7616C541.769 55.0504 558.514 63.9488 571.876 73.3347C585.577 82.8425 596.402 92.8379 604.352 103.565C612.64 114.291 618.56 125.75 621.943 138.061C625.495 150.007 627.187 162.806 627.187 176.458V248.376C627.187 261.663 630.4 273.852 636.659 284.701C643.086 295.55 653.404 304.082 667.612 309.933L667.443 366.127Z",
    fill: "url(#paint0_linear_406_131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305.135 157.808C319.513 163.781 329.83 163.903 336.089 158.295C342.516 152.688 345.561 143.18 345.561 129.894V57.9756C345.561 44.3234 347.252 32.9871 350.804 23.9669C354.356 14.581 360.107 7.99861 368.057 3.97607C376.345 0.0754228 387.17 -0.899739 400.533 0.806794C414.233 2.63522 431.148 7.75482 451.107 16.1656L460.579 20.1881V76.8694L448.57 71.8717C434.192 65.8988 424.551 65.0456 419.477 69.3119C414.741 73.7001 412.373 82.4766 412.373 95.8851V159.271C412.373 175.726 410.174 188.891 405.607 198.399C401.209 208.029 392.245 214.123 378.882 216.805C392.245 230.579 401.209 244.231 405.607 257.518C410.005 270.805 412.204 285.676 412.204 302.254V365.639C412.204 378.926 414.572 389.774 419.308 398.185C424.382 406.596 434.023 413.91 448.4 419.761L460.41 424.758V481.44L450.938 477.417C430.979 469.128 414.064 460.108 400.363 450.722C387.001 441.336 376.176 431.341 367.888 420.492C359.938 409.887 354.187 398.429 350.804 386.239C347.252 374.294 345.561 361.495 345.561 347.842V275.924C345.561 262.638 342.347 250.448 336.089 239.599C329.661 228.751 319.343 220.218 305.135 214.367V157.808Z",
    fill: "url(#paint1_linear_406_131)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M716.324 15.6782L1073.39 164.268L1073.22 781.18L716.155 632.712L716.324 15.6782Z",
    fill: "url(#paint2_linear_406_131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M649.175 96.4946L933.338 214.611V271.292L649.175 153.176V96.4946Z",
    fill: "#0E9FE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M762.84 358.935L1032.12 470.957V642.463L762.84 530.442V358.935Z",
    fill: "url(#paint3_linear_406_131)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M760.133 227.41L1033.47 341.138V360.519L760.133 246.791V227.41Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M760.133 266.416L996.427 364.664V384.045L760.133 285.798V266.416Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M760.133 304.935L960.738 388.312V407.693L760.133 324.317V304.935Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M716.324 15.6782L1073.39 164.268V246.913L716.155 98.4451L716.324 15.6782Z",
    fill: "url(#paint4_linear_406_131)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M805.463 94.6661C805.463 107.221 795.315 113.072 782.798 107.831C770.281 102.589 760.133 88.3276 760.133 75.7723C760.133 63.2171 770.281 57.3662 782.798 62.6077C795.315 67.8492 805.463 82.2328 805.463 94.6661Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M72.9011 204.616L1172 661.723L1171.83 1279L72.7319 821.893L72.9011 204.616Z",
    fill: "url(#paint5_linear_406_131)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 356.741L283.993 474.857V531.538L0 413.544V356.741Z",
    fill: "#0E9FE1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M146.985 512.523L777.555 774.842V794.223L146.985 531.905V512.523Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M146.985 551.53L690.953 777.767V797.148L146.985 570.911V551.53Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M146.985 590.17L609.933 782.764V802.146L146.985 609.551V590.17Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M572.553 835.911L1127.01 1066.54V1238.04L572.553 1007.42V835.911Z",
    fill: "url(#paint6_linear_406_131)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M614.332 887.229L697.889 921.969V978.65L614.332 943.91V887.229Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M716.664 932.573L800.221 967.313V1023.99L716.664 989.255V932.573Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M819.503 974.627L903.061 1009.37V1066.05L819.503 1031.31V974.627Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M922.343 1019.36L1005.9 1054.1V1110.78L922.343 1076.04V1019.36Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.8071 609.43L505.402 801.415V972.921L43.8071 780.814V609.43Z",
    fill: "url(#paint7_linear_406_131)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M90.3218 672.693L457.026 825.184V844.566L90.3218 692.075V672.693Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M90.3218 711.7L383.956 833.839V853.22L90.3218 730.959V711.7Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.9004 204.616L1170.48 661.235V744.855L72.9004 288.358V204.616Z",
    fill: "url(#paint8_linear_406_131)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.486 296.159C192.486 308.714 182.337 314.565 169.821 309.324C157.304 304.082 147.155 289.821 147.155 277.266C147.155 264.71 157.304 258.859 169.821 264.101C182.337 269.342 192.486 283.726 192.486 296.159Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_131",
    x1: 764.805,
    y1: 25.6318,
    x2: 601.311,
    y2: 418.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_131",
    x1: 604.871,
    y1: 2.16848,
    x2: 441.35,
    y2: 395.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_131",
    x1: 1080.1,
    y1: 167.071,
    x2: 878.577,
    y2: 651.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_131",
    x1: 949.041,
    y1: 436.301,
    x2: 893.03,
    y2: 570.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_406_131",
    x1: 838.749,
    y1: 16.9599,
    x2: 898.474,
    y2: 251.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_406_131",
    x1: 807.804,
    y1: 510.247,
    x2: 701.065,
    y2: 766.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_406_131",
    x1: 901.36,
    y1: 972.652,
    x2: 845.349,
    y2: 1107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_406_131",
    x1: 326.105,
    y1: 726.796,
    x2: 270.094,
    y2: 861.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_406_131",
    x1: 345.234,
    y1: 137.24,
    x2: 592.376,
    y2: 718.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSvg);
export default __webpack_public_path__ + "static/media/homeSVG.830522e73e104225361a59f085a76bd6.svg";
export { ForwardRef as ReactComponent };